import { render } from "./StatusInfo.vue?vue&type=template&id=78c2c4cc"
import script from "./StatusInfo.vue?vue&type=script&lang=js"
export * from "./StatusInfo.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__